// extracted by mini-css-extract-plugin
export default {"sidebarMenu":"SidebarMenu_sidebarMenu__F8fHE","applicationLogo":"SidebarMenu_applicationLogo__l46er"};